/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';
import { inject as service } from '@ember/service';

class BillingCurrentBillingPeriodChargesRoute extends Route {
  @service declare appService: AppService;

  reactEnabled() {
    return this.appService.app.canUseBillingSummaryRedesign;
  }
}

export default ReactRoute(BillingCurrentBillingPeriodChargesRoute);
